import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Pipe({ name: 'dsanitizeHtml'})

export class dsanitizeHtmlPipe implements PipeTransform  {

  constructor(private _sanitizer:DomSanitizer) { }

  transform(value:string):SafeHtml {
    return this._sanitizer.bypassSecurityTrustHtml(value);
  }
}


// WEBPACK FOOTER //
// C:/projects/wct-nextias-ui/src/app/discussion/sanitize-html.pipe.ts